export const localToBinaryFileConverter = async (document: any) => {
  return new Promise((resolve, reject) => {
    if (document) {
      const fullType = document.path.split('.');
      const docType = fullType[fullType.length - 1];
      fetch(URL.createObjectURL(document))
        .then(response => response.arrayBuffer())
        .then(arrayBuffer => {
          const blob = new Blob([arrayBuffer], { type: document.type });
          const reader = new FileReader();
          reader.onload = () => {
            if (typeof reader.result === 'string') {
              const base64String = reader.result.split(',')[1];
              const documentObject = {
                fileName: document.name,
                fileType: docType,
                uri: base64String,
                // fileData: arrayBuffer,
              };
              resolve(documentObject);
            }
          };
          reader.readAsDataURL(blob);
        })
        .catch(reject);
    } else {
      reject('No document provided');
    }
  });
};
